import angular from 'angular'
import './home/home.controller'
import './users/users.controller'
import './publishers/publishers.controller'
import './logs/logs.controller'
import './posts/posts.controller'
import './tags/tags.controller'
import './trades/trades.controller'
import './configurations/configurations.controller'
import './tips/tips.controller'
import './versions/versions.controller'
import './sync_data/sync_data.controller'
import './notifications/notifications.controller'
import './profile/profile.controller'
import './coinproduct/coinproduct.controller'
import './coinproduct_cash/coinproduct_cash.controller'
import './coinproduct_dp/coinproduct_dp.controller'
import './notification_history/notification_history.controller'
import './channel_group/channel_group.controller'
import './product_lines/product_lines.controller'
import './event/event.controller'
import './user_segmentation/user_segmentation.controller'
import './campaigns/campaigns.controller'
import './explore/explore.controller'
import './print_history/print_history.controller'
import './shelfies/shelfies.controller'
import './storyboards/storyboards.controller'
import './hashtags/hashtags.controller'
import './subscription/subscription.controller'
import './challenges/challenges.controller'
import './offers/offers.controller'
import './rewards/rewards.controller'
import './collector_levels/collector_levels.controller'
import './awards/awards.controller'
import './checklist/checklist.controller'
import './shinies/shinies.controller'
import './checklist_report/checklist_report.controller'
import './print_escrow/print_escrow.controller'
import './audiences/audiences.controller'
import './print_lookup/print_lookup.controller'
import './lookup/lookup.controller'
import './ambassador_giveaway/ambassador_giveaway.controller'
import './withdrawals/withdrawals.controller'
import './blockchain/blockchain.controller'
import './wash_trades/wash_trades.controller'
import './pack_maintenance/pack_maintenance.controller'
import './coupons/coupons.controller'
import './event_calendars/event_calendars.controller'
import './compatible_app/compatible_app.controller'
import './scheduled_message/scheduled_message.controller'
import './scheduled_configurations/scheduled_configurations.controller'
import './all_sales/all_sales.controller'
import './communities/communities.controller'
import './channel_hero_banners/channel_hero_banners.controller'
import './daily_login_banners/daily_login_banners.controller'
import './channel_prize_banners/channel_prize_banners.controller'
import './marketplace/marketplace.controller'
import './product_categories/product_categories.controller'
import './default_bounty_shinies/default_bounty_shinies.controller'
import './genres/genres.controller'
import './deposit_match/deposit_match.controller'
import './affiliates/affiliates.controller'
import './email_management/email_management.controller'
import './shinie_redemption/shinies.controller'
import './storyboard_event/storyboard_event.controller'
import './mini_game_configurations/mini_game_configurations.controller'
import './product/product.controller'
import './winners/winners.controller'

angular.module('collectibleApp.admin', [
  'admin.home',
  'admin.users',
  'admin.publishers',
  'admin.logs',
  'admin.posts',
  'admin.tags',
  'admin.trades',
  'admin.configurations',
  'admin.tips',
  'admin.versions',
  'admin.sync_data',
  'admin.notifications',
  'admin.profile',
  'admin.coinproduct',
  'admin.coinproduct_cash',
  'admin.coinproduct_dp',
  'admin.notification_history',
  'admin.channel_group',
  'admin.product_lines',
  'admin.event',
  'admin.user_segmentation',
  'admin.campaigns',
  'admin.explore',
  'admin.print',
  'admin.shelfie_elements',
  'admin.storyboard_elements',
  'admin.hashtags',
  'admin.subscription',
  'admin.challenges',
  'admin.offers',
  'admin.rewards',
  'admin.collector_levels',
  'admin.awards',
  'admin.awards',
  'admin.checklist',
  'admin.shinies',
  'admin.checklist_report',
  'admin.print_escrow',
  'admin.audiences',
  'admin.print_lookup',
  'admin.lookup',
  'admin.ambassador_giveaway',
  'admin.withdrawals',
  'admin.blockchain',
  'admin.wash_trades',
  'admin.pack_maintenance',
  'admin.coupons',
  'admin.event_calendars',
  'admin.compatible_apps',
  'admin.scheduled_messages',
  'admin.scheduled_configurations',
  'admin.all_sales',
  'admin.communities',
  'admin.channel_hero_banners',
  'admin.daily_login_banners',
  'admin.channel_prize_banners',
  'admin.marketplaces',
  'admin.product_categories',
  'admin.default_bounty_shinies',
  'admin.genres',
  'admin.deposit_match',
  'admin.affiliates',
  'admin.email_management',
  'admin.shinie_redemption',
  'admin.storyboard_event',
  'admin.mini_game_configurations',
  'admin.product',
  'admin.winners',
])
